import { ICommandBase } from "@Quest/cqrs";

export class CreateExpenseAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.CreateExpenseAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;	
	Name: string;
	Description: string;
	Classification: string;
	SubtotalId: string;

	constructor(workspaceId: number, strategyId: string, expenseId: string, name: string, description: string, classification: string, subtotalId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = expenseId;
		this.Name = name;
		this.Description = description;
		this.Classification = classification;
		this.SubtotalId = subtotalId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.CreateExpenseAccountCommandV1, TCh.Domain.Quest';
	}
}
export class DeleteExpenseAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.DeleteExpenseAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	constructor(workspaceId: number, strategyId: string, expenseId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = expenseId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.DeleteExpenseAccountCommandV1, TCh.Domain.Quest';
	}
}
export class UpdateExpenseAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateExpenseAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;
	Classification: string;
	SubtotalId: string;

	constructor(workspaceId: number, strategyId: string, expenseId: string, name: string, description: string, classification: string, subtotalId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = expenseId;
		this.Name = name;
		this.Description = description;
		this.Classification = classification;
		this.SubtotalId = subtotalId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateExpenseAccountCommandV1, TCh.Domain.Quest';
	}
}

export class CreateCostSubtotalCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.CreateCostSubtotalCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;

	constructor(workspaceId: number, strategyId: string, subtotalId: string, name: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = subtotalId;
		this.Name = name;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.CreateCostSubtotalCommandV1, TCh.Domain.Quest';
	}
}
export class DeleteCostSubtotalCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.DeleteCostSubtotalCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	constructor(workspaceId: number, strategyId: string, subtotalId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = subtotalId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.DeleteCostSubtotalCommandV1, TCh.Domain.Quest';
	}
}
export class RenameCostSubtotalCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.RenameCostSubtotalCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;

	constructor(workspaceId: number, strategyId: string, subtotalId: string, name: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = subtotalId;
		this.Name = name;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.RenameCostSubtotalCommandV1, TCh.Domain.Quest';
	}
}


export class UpdateCostAccountClassificationCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateCostAccountClassificationCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Classification: string;

	constructor(workspaceId: number, strategyId: string, costId: string, classification: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = costId;
		this.Classification = classification;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateCostAccountClassificationCommandV1, TCh.Domain.Quest';
	}
}

export class UpdateCostAccountParentCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateCostAccountParentCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	SubtotalId: string;

	constructor(workspaceId: number, strategyId: string, costId: string, subtotalId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = costId;
		this.SubtotalId = subtotalId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateCostAccountParentCommandV1, TCh.Domain.Quest';
	}
}



export class UpdateCostAccountCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateCostAccountCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;
	SubtotalId: string;
	Classification: string;

	constructor(workspaceId: number, strategyId: string, costId: string, name: string, description: string, subtotalId: string, classification: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = costId;
		this.Name = name;
		this.Description = description;
		this.SubtotalId = subtotalId;
		this.Classification = classification;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Financials.Costs.Commands.UpdateCostAccountCommandV1, TCh.Domain.Quest';
	}
}
